import { Grid, IconButton } from '@mui/material'
import { AddComment, Edit } from '@mui/icons-material'
import { Add } from '@mui/icons-material'
import PersonIcon from '@mui/icons-material/Person'
import PropTypes from 'prop-types'
import { openPopup } from '../../../../store/popupsSlice'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import EmailIcon from '@mui/icons-material/Email'
import axios from 'axios'
import { handleOpenAlert } from '../../../../lib/handleAlert'

const PatientsTableActions = ({ row }) => {
  const user = useSelector((state) => state.user.user)
  const dispatch = useDispatch()
  const sendInvitation = () => {
    axios.post(`/patients/${row.id}/login/send`, null).then(() => {
      handleOpenAlert({
        title: 'Sukces!',
        subtitle: 'Wysłano zaproszenie!',
        type: 'success',
      })
    })
  }
  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      direction="row"
      spacing={1}
      className="table-actions"
    >
      <>
        {user && user.role_id == 1 && (
          <Grid item>
            <Link to={`/patient/${row.id}/results`}>
              <IconButton size="small" title="Podgląd pacjenta">
                <PersonIcon fontSize="small" color="primary" />
              </IconButton>
            </Link>
          </Grid>
        )}
        {user && user.role_id == 2 && (
          <Grid item>
            <Link to={`/patient/${row.id}`}>
              <IconButton size="small" title="Podgląd pacjenta">
                <PersonIcon fontSize="small" color="primary" />
              </IconButton>
            </Link>
          </Grid>
        )}
        {user && user.role_id == 1 && row.email && row.active == 1 && (
          <Grid item>
            <IconButton
              size="small"
              title="Wyślij zaproszenie"
              onClick={() => {
                sendInvitation()
              }}
            >
              <EmailIcon fontSize="small" color="primary" />
            </IconButton>
          </Grid>
        )}
        {user && user.role_id == 1 && (
          <>
            <Grid item>
              <IconButton
                title="Dodaj zlecenie"
                onClick={() =>
                  dispatch(
                    openPopup({
                      component: 'ContractFactory',
                      title: 'Dodaj zlecenie',
                      level: 1,
                      maxWidth: 'xl',
                      key: 'contract-factory-popup',
                      values: {
                        patient_id: row.id,
                        patient_name: `${row.firstname} ${row.lastname}`,
                      },
                    })
                  )
                }
              >
                <Add fontSize="small" />
              </IconButton>
            </Grid>
            <Grid item>
              <IconButton
                title="Dodaj notatkę"
                onClick={() =>
                  dispatch(
                    openPopup({
                      component: 'PatientNoteFactory',
                      title: `Dodaj notatkę dla: ${row.firstname} ${row.lastname}`,
                      level: 1,
                      maxWidth: 'xl',
                      key: 'patient-note-factory-popup',
                      values: {
                        patient_id: row.id,
                      },
                    })
                  )
                }
              >
                <AddComment fontSize="small" />
              </IconButton>
            </Grid>
            <Grid item>
              <IconButton
                title="Edytuj pacjenta"
                onClick={() => {
                  dispatch(
                    openPopup({
                      component: 'PatientFactory',
                      title: 'Edytuj pacjenta',
                      level: 1,
                      values: {
                        ...row,
                      },
                      key: 'patient-factory-popup',
                    })
                  )
                }}
                size="small"
              >
                <Edit fontSize="small" />
              </IconButton>
            </Grid>
          </>
        )}
      </>
    </Grid>
  )
}

PatientsTableActions.propTypes = {
  row: PropTypes.object,
}

export default PatientsTableActions
